document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  initProductGalleryLightbox(section);

  const galleryStage = section.querySelector('[data-product-stage]');
  const galleryThumbs = Array.from(section.querySelectorAll('[data-thumb-media-id]'));
  let mainImage = section.querySelector('[data-product-main-image]');
  let isGalleryAnimating = false;
  let pendingGalleryUpdate = null;
  let galleryTransitionHandler = null;
  let galleryStartTimer = null;
  let galleryFinishTimer = null;
  let activeThumbIndex = Math.max(
    0,
    galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active'))
  );

  galleryThumbs.forEach((thumb, nextIndex) => {
    thumb.addEventListener('click', () => {
      const mediaId = thumb.getAttribute('data-thumb-media-id');
      const imageUrl = thumb.getAttribute('data-image-url');
      if (!mediaId || !imageUrl || !mainImage) return;
      if (String(mainImage.getAttribute('data-active-media-id')) === String(mediaId)) return;

      const direction = nextIndex > activeThumbIndex ? 'left' : 'right';
      updateMainImage({ mediaId, imageUrl, direction, nextIndex });
    });
  });

  const form = section.querySelector('[data-product-form]');
  const variantSelect = section.querySelector('[data-variant-id-select]');
  const variantsScript = section.querySelector('[data-product-variants]');
  const priceEl = section.querySelector('[data-product-price]');
  const submitBtn = section.querySelector('[data-product-submit]');
  const stockEl = section.querySelector('[data-option-stock]');

  if (!form || !variantSelect || !variantsScript) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    return;
  }

  const optionGroups = Array.from(section.querySelectorAll('[data-option-position]'));

  optionGroups.forEach((group) => {
    const position = Number(group.getAttribute('data-option-position'));
    const optionIndex = position - 1;
    const controls = group.querySelectorAll('[data-option-value]');

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        controls.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        control.classList.add('is-selected');
        control.setAttribute('aria-pressed', 'true');

        const swatchImageUrl = control.getAttribute('data-image-url');
        if (swatchImageUrl) {
          updateMainImage({ imageUrl: swatchImageUrl });
        }

        const matchedVariant = findVariant(getCurrentOptions(), optionIndex);
        if (!matchedVariant) {
          updateSubmitState(null);
          updateOptionAvailability();
          return;
        }

        variantSelect.value = String(matchedVariant.id);
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        updateVariantState(matchedVariant);
        updateOptionAvailability();
      });
    });
  });

  variantSelect.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === variantSelect.value);
    if (!variant) return;
    updateVariantState(variant);
  });

  function getCurrentOptions() {
    return optionGroups.map((group) => {
      const selected = group.querySelector('.is-selected[data-option-value]');
      return selected ? selected.getAttribute('data-option-value') : '';
    });
  }

  function areAllOptionsSelected() {
    return optionGroups.every((group) => group.querySelector('.is-selected[data-option-value]'));
  }

  function findVariant(options, changedOptionIndex = null) {
    const candidates = variants.filter((variant) =>
      options.every((value, index) => !value || variant.options[index] === value)
    );

    if (candidates.length > 0) {
      return candidates.find((variant) => variant.available) || candidates[0];
    }

    if (changedOptionIndex !== null && options[changedOptionIndex]) {
      const changedValue = options[changedOptionIndex];
      const fallbackCandidates = variants.filter(
        (variant) => variant.options[changedOptionIndex] === changedValue
      );

      return fallbackCandidates.find((variant) => variant.available) || fallbackCandidates[0] || null;
    }

    return null;
  }

  function formatMoney(cents) {
    const moneyFormat = section.getAttribute('data-money-format') || '';
    const noDecimalFormat = moneyFormat
      .replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator')
      .replace('amount_with_space_separator', 'amount_no_decimals_with_space_separator')
      .replace('{{amount}}', '{{amount_no_decimals}}')
      .replace('{{ amount }}', '{{amount_no_decimals}}');

    if (window.Shopify?.formatMoney && noDecimalFormat) {
      return window.Shopify.formatMoney(cents, noDecimalFormat);
    }

    const whole = Math.round(Number(cents || 0) / 100).toString();
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (noDecimalFormat) {
      return noDecimalFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grouped)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    return grouped;
  }

  function syncThumbState(mediaId, nextIndex = null) {
    if (!mediaId) return;

    galleryThumbs.forEach((item, index) => {
      const isActive = item.getAttribute('data-thumb-media-id') === String(mediaId);
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (isActive) {
        activeThumbIndex = nextIndex ?? index;
      }
    });
  }

  function createMainImage(imageUrl, mediaId) {
    const image = document.createElement('img');
    image.className = 'product-gallery__image is-current';
    image.src = imageUrl;
    image.alt = mainImage?.alt || '';
    image.decoding = 'async';
    image.setAttribute('data-product-main-image', '');
    if (mediaId) {
      image.setAttribute('data-active-media-id', mediaId);
    }
    return image;
  }

  function clearGalleryTimers() {
    if (galleryStartTimer) {
      window.clearTimeout(galleryStartTimer);
      galleryStartTimer = null;
    }

    if (galleryFinishTimer) {
      window.clearTimeout(galleryFinishTimer);
      galleryFinishTimer = null;
    }

    const track = galleryStage?.querySelector('.product-gallery__track');
    if (track && galleryTransitionHandler) {
      track.removeEventListener('transitionend', galleryTransitionHandler);
      galleryTransitionHandler = null;
    }
  }

  function settleGallery({ imageUrl, mediaId = null, nextIndex = null }) {
    if (!galleryStage || !imageUrl) return;

    clearGalleryTimers();
    isGalleryAnimating = false;
    pendingGalleryUpdate = null;

    const image = createMainImage(imageUrl, mediaId);
    galleryStage.replaceChildren(image);
    mainImage = image;
    syncThumbState(mediaId, nextIndex);
  }

  function finishTrackSlide(finalImage, mediaId, nextIndex) {
    if (!galleryStage || !finalImage) return;

    clearGalleryTimers();
    galleryStage.replaceChildren(finalImage);
    finalImage.classList.add('is-current');
    finalImage.setAttribute('data-product-main-image', '');
    if (mediaId) {
      finalImage.setAttribute('data-active-media-id', mediaId);
    }

    mainImage = finalImage;
    isGalleryAnimating = false;
    syncThumbState(mediaId, nextIndex);

    if (pendingGalleryUpdate) {
      const nextUpdate = pendingGalleryUpdate;
      pendingGalleryUpdate = null;
      updateMainImage(nextUpdate);
    }
  }

  function startTrackSlide({ imageUrl, mediaId = null, direction = 'left', nextIndex = null }) {
    if (!galleryStage || !mainImage || !imageUrl) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      settleGallery({ imageUrl, mediaId, nextIndex });
      return;
    }

    isGalleryAnimating = true;
    clearGalleryTimers();

    const currentSlide = document.createElement('div');
    currentSlide.className = 'product-gallery__slide';
    const currentImage = mainImage;
    currentImage.classList.remove('is-current');
    currentImage.removeAttribute('data-product-main-image');
    currentSlide.appendChild(currentImage);

    const nextSlide = document.createElement('div');
    nextSlide.className = 'product-gallery__slide';
    const nextImage = createMainImage(imageUrl, mediaId);
    nextImage.classList.remove('is-current');
    nextImage.removeAttribute('data-product-main-image');
    nextSlide.appendChild(nextImage);

    const track = document.createElement('div');
    track.className = 'product-gallery__track is-instant';

    if (direction === 'right') {
      track.append(nextSlide, currentSlide);
      track.style.transform = 'translateX(-50%)';
    } else {
      track.append(currentSlide, nextSlide);
      track.style.transform = 'translateX(0)';
    }

    galleryStage.replaceChildren(track);

    let slideStarted = false;
    const runSlide = () => {
      if (slideStarted || !track.isConnected) return;
      slideStarted = true;
      if (galleryStartTimer) {
        window.clearTimeout(galleryStartTimer);
        galleryStartTimer = null;
      }
      track.classList.remove('is-instant');
      track.style.transform = direction === 'right' ? 'translateX(0)' : 'translateX(-50%)';
    };

    requestAnimationFrame(() => requestAnimationFrame(runSlide));

    galleryTransitionHandler = (event) => {
      if (event.target !== track || event.propertyName !== 'transform') return;
      finishTrackSlide(nextImage, mediaId, nextIndex);
    };

    track.addEventListener('transitionend', galleryTransitionHandler);
    galleryFinishTimer = window.setTimeout(() => {
      if (!isGalleryAnimating) return;
      finishTrackSlide(nextImage, mediaId, nextIndex);
    }, 500);
  }

  function updateMainImage({ mediaId = null, imageUrl = null, direction = null, nextIndex = null }) {
    if (!imageUrl) return;

    const currentMediaId = mainImage?.getAttribute('data-active-media-id');
    if (mediaId && mainImage && String(currentMediaId) === String(mediaId)) {
      syncThumbState(mediaId, nextIndex);
      return;
    }

    if (isGalleryAnimating) {
      pendingGalleryUpdate = { mediaId, imageUrl, direction, nextIndex };
      return;
    }

    if (galleryStage && direction) {
      startTrackSlide({ imageUrl, mediaId, direction, nextIndex });
      return;
    }

    settleGallery({ imageUrl, mediaId, nextIndex });
  }

  function setActiveMedia(variant) {
    if (variant.featured_media_id) {
      const thumbIndex = galleryThumbs.findIndex(
        (item) => item.getAttribute('data-thumb-media-id') === String(variant.featured_media_id)
      );
      const thumb = thumbIndex >= 0 ? galleryThumbs[thumbIndex] : null;
      const thumbUrl = thumb?.getAttribute('data-image-url') || variant.featured_image_url;

      if (thumbUrl) {
        const direction =
          thumbIndex < 0 || thumbIndex === activeThumbIndex
            ? null
            : thumbIndex > activeThumbIndex
              ? 'left'
              : 'right';

        updateMainImage({
          mediaId: variant.featured_media_id,
          imageUrl: thumbUrl,
          direction,
          nextIndex: thumbIndex >= 0 ? thumbIndex : null,
        });
        return;
      }
    }

    if (variant.featured_image_url) {
      updateMainImage({ imageUrl: variant.featured_image_url });
    }
  }

  function updateStockMessage(variant) {
    if (!stockEl) return;
    const showOutOfStock = Boolean(variant && areAllOptionsSelected() && !variant.available);
    stockEl.hidden = !showOutOfStock;
  }

  function updateSubmitState(variant) {
    if (!submitBtn) return;

    const canSubmit = areAllOptionsSelected() && variant?.available;
    submitBtn.disabled = !canSubmit;
    submitBtn.textContent = variant && !variant.available && areAllOptionsSelected()
      ? submitBtn.getAttribute('data-label-sold-out') || window.SculptStrings?.productsSoldOut || 'Sold out'
      : submitBtn.getAttribute('data-label-available') || window.SculptStrings?.productsAddToCart || 'Add to cart';
    updateStockMessage(variant);
  }

  function isColorGroup(group) {
    return group.querySelector('.product-option__swatches') !== null;
  }

  function updateOptionAvailability() {
    const currentOptions = getCurrentOptions();

    optionGroups.forEach((group, optionIndex) => {
      const controls = group.querySelectorAll('[data-option-value]');
      const isColor = isColorGroup(group);

      controls.forEach((control) => {
        const value = control.getAttribute('data-option-value');

        if (isColor) {
          const colorVariants = variants.filter((variant) => variant.options[optionIndex] === value);
          const allSoldOut = colorVariants.length > 0 && colorVariants.every((variant) => !variant.available);
          control.classList.toggle('is-sold-out', allSoldOut);
          control.classList.remove('is-unavailable');
          return;
        }

        const testOptions = [...currentOptions];
        testOptions[optionIndex] = value;
        const exists = findVariant(testOptions, optionIndex);
        const unavailable = exists ? !exists.available : false;
        control.classList.toggle('is-unavailable', unavailable);
        control.classList.remove('is-sold-out');
        control.disabled = false;
        control.removeAttribute('aria-disabled');
      });
    });
  }

  function updateVariantState(variant) {
    if (priceEl) {
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEl.innerHTML = hasCompare
        ? `<span class="product-info__price-sale">${formatMoney(variant.price)}</span><s class="product-info__price-compare">${formatMoney(variant.compare_at_price)}</s>`
        : `<span>${formatMoney(variant.price)}</span>`;
    }

    updateSubmitState(variant);
    setActiveMedia(variant);

    if (areAllOptionsSelected()) {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', nextUrl.toString());
    }
  }

  function selectDefaultVariant() {
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    const defaultVariant =
      variants.find((item) => String(item.id) === String(urlVariantId)) ||
      variants.find((item) => String(item.id) === String(variantSelect.value)) ||
      variants.find((item) => item.available) ||
      variants[0];

    if (!defaultVariant) {
      updateSubmitState(null);
      updateOptionAvailability();
      return;
    }

    optionGroups.forEach((group, optionIndex) => {
      const value = defaultVariant.options[optionIndex];
      const controls = group.querySelectorAll('[data-option-value]');
      controls.forEach((control) => {
        const isSelected = control.getAttribute('data-option-value') === value;
        control.classList.toggle('is-selected', isSelected);
        control.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    });

    variantSelect.value = String(defaultVariant.id);
    updateVariantState(defaultVariant);
    updateOptionAvailability();

    // Sync wishlist button ke variant default
    const wishlistBtn =
      document.getElementById('smartwishlist') || document.querySelector('.product-gallery__wishlist');
    if (wishlistBtn) {
      wishlistBtn.setAttribute('data-variant', String(defaultVariant.id));
      if (window.jQuery) window.jQuery(wishlistBtn).data('variant', String(defaultVariant.id));
    }
  }

  selectDefaultVariant();
});

function initProductGalleryLightbox(section) {
  const stage = section.querySelector('[data-product-stage]');
  const lightbox = section.querySelector('[data-product-lightbox]');
  const galleryScript = section.querySelector('[data-product-gallery-images]');

  if (!stage || !lightbox || !galleryScript) return;

  let galleryImages = [];
  try {
    galleryImages = JSON.parse(galleryScript.textContent);
  } catch (error) {
    return;
  }

  if (!galleryImages.length) return;

  const lightboxViewport = lightbox.querySelector('[data-lightbox-viewport]');
  const lightboxTrack = lightbox.querySelector('[data-lightbox-track]');
  const zoomBtn = lightbox.querySelector('[data-lightbox-zoom]');
  const fullscreenBtn = lightbox.querySelector('[data-lightbox-fullscreen]');
  const closeBtn = lightbox.querySelector('[data-lightbox-close]');
  const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  const nextBtn = lightbox.querySelector('[data-lightbox-next]');

  let currentIndex = 0;
  let isZoomed = false;
  let isSliding = false;
  let lockedScrollY = 0;
  let panX = 0;
  let panY = 0;
  let activePointerId = null;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let panStartX = 0;
  let panStartY = 0;
  let dragMode = null;
  let dragDeltaX = 0;
  let swipeDirection = null;

  const SWIPE_THRESHOLD = 48;
  const DRAG_ACTIVATE = 10;

  const lockPageScroll = () => {
    lockedScrollY = window.scrollY;
    document.documentElement.classList.add('is-product-lightbox-open');
    document.body.classList.add('is-product-lightbox-open');
    document.body.style.top = `-${lockedScrollY}px`;
  };

  const unlockPageScroll = () => {
    document.documentElement.classList.remove('is-product-lightbox-open');
    document.body.classList.remove('is-product-lightbox-open');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  };

  const getMainImage = () => stage.querySelector('[data-product-main-image]');

  const getCurrentIndex = () => {
    const image = getMainImage();
    if (!image) return 0;

    const mediaId = image.getAttribute('data-active-media-id');
    const index = galleryImages.findIndex((item) => String(item.id) === String(mediaId));
    return index >= 0 ? index : 0;
  };

  const getViewportWidth = () => lightboxViewport?.clientWidth || 0;

  const createSlideImage = (item) => {
    const image = document.createElement('img');
    image.className = 'product-lightbox__image';
    image.src = item.url;
    image.alt = item.alt || '';
    image.decoding = 'async';
    return image;
  };

  const createSlide = (item) => {
    const slide = document.createElement('div');
    slide.className = 'product-lightbox__slide';
    slide.appendChild(createSlideImage(item));
    return slide;
  };

  const getActiveLightboxImage = () =>
    lightboxTrack?.querySelector('.product-lightbox__slide:first-child .product-lightbox__image');

  const applyImageTransform = () => {
    const image = getActiveLightboxImage();
    if (!image) return;

    image.style.setProperty('--lightbox-pan-x', `${panX}px`);
    image.style.setProperty('--lightbox-pan-y', `${panY}px`);
  };

  const resetImageTransform = () => {
    panX = 0;
    panY = 0;
    applyImageTransform();
  };

  const resetZoomState = () => {
    isZoomed = false;
    lightboxViewport?.classList.remove('is-zoomed');
    zoomBtn?.setAttribute('aria-pressed', 'false');
    resetImageTransform();
  };

  const resetPointerState = () => {
    activePointerId = null;
    dragMode = null;
    dragDeltaX = 0;
    swipeDirection = null;
    lightboxViewport?.classList.remove('is-dragging', 'is-panning');
  };

  const setTrackOffset = (offsetPx, instant = false) => {
    if (!lightboxTrack) return;

    lightboxTrack.classList.toggle('is-instant', instant);
    lightboxTrack.style.transform = `translateX(${offsetPx}px)`;
  };

  const renderLightboxImage = () => {
    const item = galleryImages[currentIndex];
    if (!item || !lightboxTrack) return;

    lightboxTrack.replaceChildren(createSlide(item));
    lightboxTrack.classList.remove('is-instant', 'is-paired');
    lightboxTrack.style.transform = '';
    resetZoomState();
    lightboxViewport?.classList.remove('is-dragging', 'is-panning', 'is-sliding');
  };

  const closeLightbox = () => {
    lightbox.hidden = true;
    unlockPageScroll();
    resetPointerState();
    resetZoomState();
    isSliding = false;
    lightboxViewport?.classList.remove('is-sliding');

    if (document.fullscreenElement) {
      document.exitFullscreen?.();
    }
  };

  const openLightbox = (index = getCurrentIndex()) => {
    currentIndex = index;
    renderLightboxImage();
    lightbox.hidden = false;
    lockPageScroll();
  };

  const slideToIndex = (nextIndex, direction) => {
    if (!lightboxTrack || galleryImages.length <= 1 || isSliding) return;

    const viewportWidth = getViewportWidth();
    if (!viewportWidth) {
      currentIndex = nextIndex;
      renderLightboxImage();
      return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      currentIndex = nextIndex;
      renderLightboxImage();
      return;
    }

    const currentItem = galleryImages[currentIndex];
    const nextItem = galleryImages[nextIndex];
    if (!currentItem || !nextItem) return;

    isSliding = true;
    resetZoomState();
    lightboxViewport?.classList.add('is-sliding');

    const currentSlide = createSlide(currentItem);
    const nextSlide = createSlide(nextItem);

    lightboxTrack.replaceChildren(currentSlide, nextSlide);
    lightboxTrack.classList.add('is-paired');

    if (direction === 'next') {
      setTrackOffset(0, true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTrackOffset(-viewportWidth);
        });
      });
    } else {
      setTrackOffset(-viewportWidth, true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTrackOffset(0);
        });
      });
    }

    const finishSlide = () => {
      if (!isSliding) return;

      currentIndex = nextIndex;
      isSliding = false;
      lightboxViewport?.classList.remove('is-sliding');
      renderLightboxImage();
    };

    const onTransitionEnd = (event) => {
      if (event.target !== lightboxTrack || event.propertyName !== 'transform') return;
      lightboxTrack.removeEventListener('transitionend', onTransitionEnd);
      finishSlide();
    };

    lightboxTrack.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finishSlide, 400);
  };

  const showPrev = () => {
    if (galleryImages.length <= 1) return;
    const nextIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    slideToIndex(nextIndex, 'prev');
  };

  const showNext = () => {
    if (galleryImages.length <= 1) return;
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    slideToIndex(nextIndex, 'next');
  };

  const prepareSwipeTrack = (direction) => {
    if (!lightboxTrack || galleryImages.length <= 1) return;

    const viewportWidth = getViewportWidth();
    if (!viewportWidth) return;

    const currentItem = galleryImages[currentIndex];
    const adjacentIndex =
      direction === 'next'
        ? (currentIndex + 1) % galleryImages.length
        : (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    const adjacentItem = galleryImages[adjacentIndex];
    if (!currentItem || !adjacentItem) return;

    const currentSlide = createSlide(currentItem);
    const adjacentSlide = createSlide(adjacentItem);

    if (direction === 'next') {
      lightboxTrack.replaceChildren(currentSlide, adjacentSlide);
      setTrackOffset(0, true);
    } else {
      lightboxTrack.replaceChildren(adjacentSlide, currentSlide);
      setTrackOffset(-viewportWidth, true);
    }

    lightboxTrack.classList.add('is-paired');
    swipeDirection = direction;
  };

  const updateSwipeOffset = (deltaX) => {
    const viewportWidth = getViewportWidth();
    if (!lightboxTrack || !viewportWidth || !swipeDirection) return;

    if (swipeDirection === 'next') {
      const offset = Math.min(0, Math.max(-viewportWidth, deltaX));
      setTrackOffset(offset, true);
      return;
    }

    const offset = Math.min(0, Math.max(-viewportWidth, -viewportWidth + deltaX));
    setTrackOffset(offset, true);
  };

  const commitSwipe = () => {
    const viewportWidth = getViewportWidth();
    if (!lightboxTrack || !viewportWidth || !swipeDirection) return;

    isSliding = true;
    lightboxViewport?.classList.add('is-sliding');

    const nextIndex =
      swipeDirection === 'next'
        ? (currentIndex + 1) % galleryImages.length
        : (currentIndex - 1 + galleryImages.length) % galleryImages.length;

    const finishSwipe = () => {
      currentIndex = nextIndex;
      isSliding = false;
      swipeDirection = null;
      lightboxViewport?.classList.remove('is-sliding');
      renderLightboxImage();
    };

    if (swipeDirection === 'next') {
      setTrackOffset(-viewportWidth);
    } else {
      setTrackOffset(0);
    }

    const onTransitionEnd = (event) => {
      if (event.target !== lightboxTrack || event.propertyName !== 'transform') return;
      lightboxTrack.removeEventListener('transitionend', onTransitionEnd);
      finishSwipe();
    };

    lightboxTrack.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finishSwipe, 400);
  };

  const cancelSwipe = () => {
    const viewportWidth = getViewportWidth();
    if (!lightboxTrack || !viewportWidth || !swipeDirection) {
      renderLightboxImage();
      return;
    }

    isSliding = true;
    lightboxViewport?.classList.add('is-sliding');

    const finishCancel = () => {
      isSliding = false;
      swipeDirection = null;
      lightboxViewport?.classList.remove('is-sliding');
      renderLightboxImage();
    };

    if (swipeDirection === 'next') {
      setTrackOffset(0);
    } else {
      setTrackOffset(-viewportWidth);
    }

    const onTransitionEnd = (event) => {
      if (event.target !== lightboxTrack || event.propertyName !== 'transform') return;
      lightboxTrack.removeEventListener('transitionend', onTransitionEnd);
      finishCancel();
    };

    lightboxTrack.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finishCancel, 400);
  };

  const toggleZoom = () => {
    isZoomed = !isZoomed;

    if (!isZoomed) {
      resetImageTransform();
    }

    lightboxViewport?.classList.toggle('is-zoomed', isZoomed);
    zoomBtn?.setAttribute('aria-pressed', isZoomed ? 'true' : 'false');
  };

  const handleViewportPointerDown = (event) => {
    if (event.button !== 0 || !lightboxViewport || lightbox.hidden || isSliding) return;

    activePointerId = event.pointerId;
    pointerStartX = event.clientX;
    pointerStartY = event.clientY;
    panStartX = panX;
    panStartY = panY;
    dragMode = null;
    dragDeltaX = 0;
    swipeDirection = null;
    lightboxViewport.setPointerCapture(event.pointerId);
  };

  const handleViewportPointerMove = (event) => {
    if (event.pointerId !== activePointerId || !lightboxViewport || isSliding) return;

    const deltaX = event.clientX - pointerStartX;
    const deltaY = event.clientY - pointerStartY;

    if (!dragMode) {
      if (Math.hypot(deltaX, deltaY) < DRAG_ACTIVATE) return;

      if (isZoomed) {
        dragMode = 'pan';
        lightboxViewport.classList.add('is-dragging', 'is-panning');
      } else if (Math.abs(deltaX) > Math.abs(deltaY) && galleryImages.length > 1) {
        dragMode = 'swipe';
        lightboxViewport.classList.add('is-dragging');
        prepareSwipeTrack(deltaX < 0 ? 'next' : 'prev');
      } else {
        dragMode = 'ignore';
      }
    }

    if (dragMode === 'pan') {
      panX = panStartX + deltaX;
      panY = panStartY + deltaY;
      applyImageTransform();
      event.preventDefault();
      return;
    }

    if (dragMode === 'swipe') {
      dragDeltaX = deltaX;
      updateSwipeOffset(deltaX);
      event.preventDefault();
    }
  };

  const handleViewportPointerUp = (event) => {
    if (event.pointerId !== activePointerId || !lightboxViewport) return;

    lightboxViewport.releasePointerCapture(event.pointerId);

    const deltaX = event.clientX - pointerStartX;
    const deltaY = event.clientY - pointerStartY;
    const moved = Math.hypot(deltaX, deltaY);

    if (dragMode === 'swipe' && Math.abs(dragDeltaX) >= SWIPE_THRESHOLD) {
      commitSwipe();
    } else if (dragMode === 'swipe') {
      cancelSwipe();
    } else if (dragMode === 'pan') {
      applyImageTransform();
    } else if (!dragMode && moved < DRAG_ACTIVATE) {
      toggleZoom();
    }

    resetPointerState();
  };

  const handleViewportPointerCancel = (event) => {
    if (event.pointerId !== activePointerId) return;

    if (dragMode === 'swipe') {
      cancelSwipe();
    }

    resetPointerState();
  };

  const toggleFullscreen = () => {
    const target = lightboxViewport || lightbox;

    if (!document.fullscreenElement) {
      target.requestFullscreen?.();
      return;
    }

    document.exitFullscreen?.();
  };

  stage.addEventListener('click', () => {
    openLightbox();
  });

  stage.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    openLightbox();
  });

  closeBtn?.addEventListener('click', closeLightbox);
  prevBtn?.addEventListener('click', showPrev);
  nextBtn?.addEventListener('click', showNext);
  zoomBtn?.addEventListener('click', toggleZoom);
  fullscreenBtn?.addEventListener('click', toggleFullscreen);

  lightboxViewport?.addEventListener('pointerdown', handleViewportPointerDown);
  lightboxViewport?.addEventListener('pointermove', handleViewportPointerMove);
  lightboxViewport?.addEventListener('pointerup', handleViewportPointerUp);
  lightboxViewport?.addEventListener('pointercancel', handleViewportPointerCancel);

  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) {
      closeLightbox();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (lightbox.hidden) return;

    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showPrev();
    if (event.key === 'ArrowRight') showNext();
  });
}
